// import React, { useEffect, useState } from "react";
// import SideNavBar from "../SideNavBar";
// import ChatContextProvider from "../../contexts/ChatContext";
// import Contacts from "../ChatBox/Contacts/Contacts";
// import Main from "../ChatBox/Main/Main";
// import { Box , Button} from "@mui/material";
// import { QueryClientProvider, QueryClient } from "react-query";
// import VideoState from "../../contexts/VideoState";
// import CallModal from "../ChatBox/options/CallModal";
// import VideoChat from "../ChatBox/Calling/VideoChat";
// import { withRouter } from 'react-router-dom';
// import { useSelector } from "react-redux";

// const queryClient = new QueryClient();

// const ChatBoxPage = () => {
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);
//   console.log('windowWidthjj:', windowWidth, showChats);

//   // const { InboxId = '', GroupInboxId = '' } = (history.location.state || {});

//   return (
//     <SideNavBar>
//          <ChatContextProvider>
//         <QueryClientProvider client={queryClient}>
//           <Box display='flex' flexDirection={windowWidth < 769 ? "column" : "row"} maxHeight='80vh' style={{ overflowY: "auto" }}>
//           <CallModal />
//           <VideoChat />
//           {windowWidth < 769 && showChats ? ( null ) : ( <Contacts />)}
//             <Main/>
//           </Box>
//         </QueryClientProvider>
//       </ChatContextProvider>
//     </SideNavBar>
//   );
// };

// export default ChatBoxPage;



// import React, { useEffect, useState } from "react";
// import SideNavBar from "../SideNavBar";
// import ChatContextProvider from "../../contexts/ChatContext";
// import Contacts from "../ChatBox/Contacts/Contacts";
// import Main from "../ChatBox/Main/Main";
// import { Box , Button} from "@mui/material";
// import { QueryClientProvider, QueryClient } from "react-query";
// import VideoState from "../../contexts/VideoState";
// import CallModal from "../ChatBox/options/CallModal";
// import VideoChat from "../ChatBox/Calling/VideoChat";
// import { withRouter } from 'react-router-dom';
// import { useSelector } from "react-redux";

// const queryClient = new QueryClient();

// const ChatBoxPage = () => {
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
  
//   return (
//     <SideNavBar>
//       <ChatContextProvider>
//         <QueryClientProvider client={queryClient}>
//           <Box 
//             sx={{
//               display: 'flex',
//               height: 'calc(100vh - 64px)', // Adjust based on your navbar height
//               width: '100%',
//               overflow: 'hidden',
//               bgcolor: '#f0f2f5'
//             }}
//           >
//             <CallModal />
//             <VideoChat />
            
//             {/* Left Contacts Sidebar - Fixed Width */}
//             <Box 
//               sx={{
//                 width: '400px',
//                 minWidth: '400px',
//                 height: '100%',
//                 bgcolor: 'white',
//                 borderRight: '1px solid #e0e0e0',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden'
//               }}
//             >
//               <Contacts />
//             </Box>
            
//             {/* Right Main Chat Area - Takes remaining space */}
//             <Box 
//               sx={{
//                 flex: 1,
//                 height: '100%',
//                 bgcolor: '#f0f2f5',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 overflow: 'hidden'
//               }}
//             >
//               <Main />
//             </Box>
//           </Box>
//         </QueryClientProvider>
//       </ChatContextProvider>
//     </SideNavBar>
//   );
// };

// export default ChatBoxPage;



import React, { useEffect, useState } from "react";
import SideNavBar from "../SideNavBar";
import ChatContextProvider from "../../contexts/ChatContext";
import Contacts from "../ChatBox/Contacts/Contacts";
import Main from "../ChatBox/Main/Main";
import { Box, Paper, Typography, Breadcrumbs, Link } from "@mui/material";
import { QueryClientProvider, QueryClient } from "react-query";
import CallModal from "../ChatBox/options/CallModal";
import VideoChat from "../ChatBox/Calling/VideoChat";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const queryClient = new QueryClient();

const ChatBoxPage = () => {
  const { showChats, showContacts } = useSelector((state) => state.manageChat);
   const history = useHistory(); 

   const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    history.push(path);
  };

  return (
    <SideNavBar>
      <ChatContextProvider>
        <QueryClientProvider client={queryClient}>
          <Box sx={{ mb: 2, px: 2, pt: 2 }}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                },
              }}
            >
              <Breadcrumbs
                separator={
                  <NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />
                }
                aria-label="breadcrumb"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 1,
                  }}
                >
                  <Link
                    to="/myteam"
                    onClick={(e) => handleBreadcrumbClick(e, "/myteam")}
                    style={{
                      textDecoration: "none",
                      color: "#667eea",
                      fontWeight: 500,
                      fontSize: "0.95rem",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(102, 126, 234, 0.08)";
                      e.currentTarget.style.color = "#764ba2";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#667eea";
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                    Teams
                  </Link>
                  <NavigateNextIcon
                    fontSize="small"
                    sx={{ color: "#667eea", mx: 0.5 }}
                  />
                  <Typography
                    sx={{
                      color: "#1a1a1a",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      backgroundColor: "rgba(102, 126, 234, 0.08)",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                    Chat
                  </Typography>
                </Box>
              </Breadcrumbs>
            </Paper>
          </Box>

          <Box 
            sx={{
              display: 'flex',
              height: 'calc(100vh - 64px)',
              width: '100%',
              overflow: 'hidden',
              bgcolor: '#f0f2f5'
            }}
          >
            <CallModal />
            <VideoChat />
            
            <Box 
              sx={{
                width: '370px',
                minWidth: '370px',
                maxWidth: '370px',
                height: '100%',
                minHeight: '89vh',
                maxHeight: '89vh',
                bgcolor: 'white',
                borderRight: '1px solid #e0e0e0',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <Contacts />
            </Box>

            <Box 
              sx={{
                flex: 1,
                height: '100%',
                minHeight: '89vh',
                maxHeight: '89vh',
                bgcolor: '#f0f2f5',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              <Main />
            </Box>
          </Box>
        </QueryClientProvider>
      </ChatContextProvider>
    </SideNavBar>
  );
};

export default ChatBoxPage;